export default __webpack_public_path__ + "static/media/WLTH_Leaves_Loop_v001.cebb804b.gif";